import { IoMdArrowBack } from "react-icons/io"
import { useNavigate } from "react-router-dom";

const PrivacySafety = () => {
    const navigate = useNavigate();

    const privacyOptions = [
        { title: "Community Guidelines", path: "/community-guidelines" },
        { title: "Privacy Policy", path: "/privacy-policy" },
        { title: "Terms and Conditions", path: "/terms-of-use" },
    ];

    return (
        <div className="h-full bg-white dark:bg-[#1E1D21]">
            {/* Header */}
            <div className="sticky top-0 z-10">
                <div className="relative bg-[#BDE6FF] rounded-b-xl h-12 flex items-center justify-center">
                    <IoMdArrowBack
                        onClick={() => navigate(-1)}
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-[22px] text-black dark:text-black cursor-pointer"
                    />
                    <p className="font-bold text-[18px] text-black dark:text-black">Privacy & Safety</p>
                </div>
            </div>

            <p className="text-[14px] text-center text-black dark:text-white p-3 mx-3 mt-3 rounded-md border-2 border-[#BDE6FF] dark:border-[#333333]">
                If you have a privacy concern please message privacy@chaachingg.com
            </p>

            {/* Privacy Options */}
            <div className="grid grid-cols-12 gap-2 p-3">
                {privacyOptions.map((option, index) => (
                    <div
                        key={index}
                        onClick={() => option.path && navigate(option.path)}
                        className={`w-full flex flex-wrap items-center justify-center p-5 rounded-md bg-[#BDE6FF] dark:bg-[#333333] cursor-pointer hover:scale-105 transition-transform duration-200
                            ${option.title === "Community Guidelines" ? "col-span-12 h-40 max-w-[calc(50%-4px)] mx-auto" : "col-span-6 h-40"}`}
                    >
                        <p className="text-[16px] font-bold text-center text-black dark:text-white">{option.title}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default PrivacySafety